<template>
  <div>
    <loading-component
      :requestData="requestInput"
      :title="title"
      :check_in_date="check_in_date"
      :check_out_date="check_out_date"
      v-show="loading"
      class="loading"
    />
    <div class="row filter-manager">
      <div class="col-xs-12 col-md-3 result-on-bar" id="filterby">
        <div class="floater_left">
          <span style="margin-right: 10px; font-size: 1.1em">&#9776;</span
          >Filter By
        </div>
        <span id="filter_arrows_indicator" class="floater_right">
          <i class="fa fa-angle-double-left" aria-hidden="true"></i>
        </span>
      </div>
      <div class="col-xs-12 col-md-9">
        <div class="row">
          <div class="col-md-6 col-md-offset-6 col-xs-12 map">
            <div class="search-top-options">
              <button
                v-on:click="updateMap"
                v-show="!mapView"
                style="background: none; border: none !important"
              >
                <i class="fa fa-map-marker" aria-hidden="true"></i> MAP VIEW
              </button>
              <button
                v-on:click="updateMap"
                v-show="mapView"
                style="background: none; border: none !important"
              >
                <i class="fa fa-list" aria-hidden="true"></i> LIST VIEW
              </button>

              <div class="form-inline">
                <select
                  v-model="selectedSortOption"
                  class="form-control dropdown"
                >
                  <option v-for="(label, key) in sortOptions" :value="key">
                    <span v-text="label"></span>
                  </option>
                </select>
                <i class="fa fa-sort-desc" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" id="columnsearch">
      <div class="col-xs-12 col-md-3 search_opt_col">
        <div class="div-sticky" style="display: none">
          <a href="javascript:void(0)" class="closebtn" style="display: none"
            >&times;</a
          >
        </div>

        <div class="col text-center">
          <button v-on:click="resetFilter" class="reset-filter">
            Reset Filters
          </button>
        </div>

        <div
          class="search-components filters"
          style="margin-top: 3rem"
          v-if="hotels.length"
        >
          <div>
            <h4 class="search-h4"><strong>Total Price</strong></h4>
            <p>
              <input
                type="text"
                id="amount"
                readonly
                style="border: 0; color: #f6931f; font-weight: bold"
              />
            </p>
            <div id="slider-range"></div>
            <hr />
          </div>
          <h4 class="search-h4"><strong>Number of Rooms</strong></h4>
          <p>
            <input
              type="text"
              id="miles"
              readonly
              style="border: 0; color: #f6931f; font-weight: bold"
            />
          </p>
          <div id="slider-range-distance"></div>

          <div
            class="privateup-amenities filter-options"
            v-if="virtuosoAmenities.length"
          >
            <h4 class="search-h4"><strong>Member Benefits</strong></h4>
            <div
              v-for="virtuosoAmenity in virtuosoAmenities"
              :key="virtuosoAmenity.code"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`privateup-amenities-${virtuosoAmenity.virtuoso_amenityid}`"
                    v-model="selectedFilters"
                    :value="virtuosoAmenity.code"
                  />
                  <label
                    :for="`privateup-amenities-${virtuosoAmenity.virtuoso_amenityid}`"
                  >
                  </label>
                  <span
                    :for="`privateup-amenities-${virtuosoAmenity.virtuoso_amenityid}`"
                    v-text="virtuosoAmenity.description"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="privateup-promotions filter-options"
            v-if="virtuosoPromotions.length"
          >
            <h4 class="search-h4"><strong>Promotions</strong></h4>
            <div
              v-for="virtuosoPromotion in virtuosoPromotions"
              :key="virtuosoPromotion.code"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`privateup-promotions-${virtuosoPromotion.virtuoso_promotionid}`"
                    v-model="selectedFilters"
                    :value="virtuosoPromotion.code"
                  />
                  <label
                    :for="`privateup-promotions-${virtuosoPromotion.virtuoso_promotionid}`"
                  >
                  </label>
                  <span
                    :for="`privateup-promotions-${virtuosoPromotion.virtuoso_promotionid}`"
                    v-text="virtuosoPromotion.description"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="private-hotel-recreation filter-options"
            v-if="privateHotelRecreations.length"
          >
            <h4 class="search-h4"><strong>Recreation</strong></h4>
            <div
              v-for="recreation in privateHotelRecreations"
              :key="recreation.pu_title"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`private-hotel-recreation-${recreation.virtuoso_catalogid}`"
                    v-model="selectedFilters"
                    :value="recreation.pu_title"
                  />
                  <label
                    :for="`private-hotel-recreation-${recreation.virtuoso_catalogid}`"
                  >
                  </label>
                  <span
                    :for="`private-hotel-recreation-${recreation.virtuoso_catalogid}`"
                    v-text="recreation.pu_title"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="private-hotel-feature filter-options"
            v-if="privateHotelFeatures.length"
          >
            <h4 class="search-h4"><strong>Facilities</strong></h4>
            <div
              v-for="feature in privateHotelFeatures"
              :key="feature.pu_title"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`private-hotel-feature-${feature.virtuoso_catalogid}`"
                    v-model="selectedFilters"
                    :value="feature.pu_title"
                  />
                  <label
                    :for="`private-hotel-feature-${feature.virtuoso_catalogid}`"
                  >
                  </label>
                  <span
                    :for="`private-hotel-feature-${feature.virtuoso_catalogid}`"
                    v-text="feature.pu_title"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="private-experience filter-options"
            v-if="privateHotelExperiences.length"
          >
            <h4 class="search-h4"><strong>Experience</strong></h4>
            <div
              v-for="experience in privateHotelExperiences"
              :key="experience.pu_title"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`private-experience-${experience.virtuoso_catalogid}`"
                    v-model="selectedFilters"
                    :value="experience.pu_title"
                  />
                  <label
                    :for="`private-experience-${experience.virtuoso_catalogid}`"
                  >
                  </label>
                  <span
                    :for="`private-experience-${experience.virtuoso_catalogid}`"
                    v-text="experience.pu_title"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="private-room filter-options"
            v-if="privateHotelRoomsStyles.length"
          >
            <h4 class="search-h4"><strong>Room Style</strong></h4>
            <div
              v-for="roomStyle in privateHotelRoomsStyles"
              :key="roomStyle.pu_title"
            >
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`private-room-${roomStyle.virtuoso_catalogid}`"
                    v-model="selectedFilters"
                    :value="roomStyle.pu_title"
                  />
                  <label :for="`private-room-${roomStyle.virtuoso_catalogid}`">
                  </label>
                  <span
                    :for="`private-room-${roomStyle.virtuoso_catalogid}`"
                    v-text="roomStyle.pu_title"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <br />
          <div
            class="private-vibe filter-options"
            v-if="privateHotelVibes.length"
          >
            <h4 class="search-h4"><strong>Hotel Style</strong></h4>
            <div v-for="vibe in privateHotelVibes" :key="vibe.pu_title">
              <div class="col-xs-12" style="display: block">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :id="`private-vibe-${vibe.virtuoso_catalogid}`"
                    v-model="selectedFilters"
                    :value="vibe.pu_title"
                  />
                  <label :for="`private-vibe-${vibe.virtuoso_catalogid}`">
                  </label>
                  <span
                    :for="`private-vibe-${vibe.virtuoso_catalogid}`"
                    v-text="vibe.pu_title"
                  ></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9 col-xs-12 hotellist">
        <div id="hotel-list-div" v-show="!mapView">
          <div
            class="hotels-list"
            v-if="hotels.length > 0"
            ref="scrollContainer"
          >
            <div class="row search_item" v-for="hotel in orderedHotels">
              <div
                class="images-lazy col-xs-12 col-sm-5 col-md-4 image-wrap"
                style="padding: 0px"
              >
                <a
                  rel="nofollow"
                  :href="hotel.hotel_url"
                  class="image-link lazy"
                  :data-src="hotel.thumbnail_url"
                  :style="{
                    'background-image': `url(${hotel.thumbnail_url})`,
                    'background-size': 'cover',
                    'background-position': 'center center',
                    'background-repeat': 'no-repeat',
                    'background-color': '#aba9a9',
                  }"
                >
                  <div v-if="hotel.is_featured" id="ribbon">
                    <span id="contentRibbon">POPULAR HOTEL</span>
                  </div>
                  <div
                    v-if="hotel.is_new"
                    id="ribbon"
                    style="background-color: #7d49b8 !important"
                  >
                    <span id="contentRibbon">NEW HOTEL</span>
                  </div>
                </a>
              </div>

              <div
                class="col-xs-12 col-sm-4 col-md-5 hotel-resume-description mt-2"
              >
                <h3
                  class="hotel-title"
                  :data-hotel-id="hotel.hotelid"
                  :data-hotel-code="hotel.hotel_code"
                  :data-chain-code="hotel.chain_code"
                >
                  <a rel="nofollow" class="hotelname" :href="hotel.hotel_url">
                    <span v-text="hotel.name"></span>
                  </a>
                </h3>

                <div v-if="localEnv">
                  hotel-id: <span v-text="hotel.hotelid"></span> <br />
                  hotel-code: <span v-text="hotel.hotel_code"></span> <br />
                  chain-code: <span v-text="hotel.chain_code"></span>
                </div>

                <div class="testdescription">
                  <span class="address ff-roboto"
                    ><i class="fa fa-map-marker" aria-hidden="true"></i
                  ></span>
                  <a :href="hotel.url_by_city" title="city"
                    ><span v-text="hotel.city_name"></span></a
                  >,
                  <a :href="hotel.url_by_country" title="country"
                    ><span v-text="hotel.country_name"></span
                  ></a>
                  <div class="badges">
                    <div v-if="hotel.is_seasonal">
                      <span class="label label-seasonal">seasonal hotel</span>
                    </div>
                    <div v-if="hotel.is_opening_soon">
                      <span class="label label-opening_soon">opening soon</span>
                    </div>
                  </div>
                </div>

                <div>
                  <ul class="nav navbar-nav hotel-icons">
                    <li>
                      <i class="fa fa-bed hotel-bed"></i>
                      <span
                        class="label label-orange"
                        v-text="hotel.room_count"
                      ></span>
                    </li>
                    <li v-for="amenity in hotel.icon_amenities">
                      <i v-if="amenity.icon !== null"
                        ><img
                          :src="amenity.icon"
                          :alt="amenity.title"
                          :title="amenity.title"
                      /></i>
                    </li>
                  </ul>
                </div>

                <p class="hotel-resume-description ellipsis">
                  <span v-html="hotel.description"></span>
                </p>
              </div>

              <div class="col-xs-12 col-sm-3 col-md-3 itemprice">
                <p
                  class="price from"
                  v-show="hotel.min_price > 0"
                  style="margin: 10px 0 20px 0; font-size: small !important"
                >
                  <strong>Rates incl. taxes from</strong>
                </p>
                <template v-if="hotel.min_price > 0">
                  <p class="price price-night">
                    <strong>{{
                      Number(hotel.min_night_price).toLocaleString()
                    }}</strong>
                    {{ hotel.currency_code }} / Night
                  </p>
                  <!--                  <p class="price price-night">-->
                  <!--                    {{ hotel.room_count }} Rooms-->
                  <!--                  </p>-->
                  <template v-if="!oneNight">
                    <p class="price price-stay" v-if="hotel.min_price > 0">
                      <strong>{{ hotel.min_price }}</strong>
                      {{ hotel.currency_code }} / Stay
                    </p>
                  </template>
                </template>
                <p
                  v-else
                  class="price price-night"
                  style="text-align: center; margin-top: 25px"
                >
                  Not available
                </p>

                <div v-if="authCheck">
                  <a
                    rel="nofollow"
                    :href="hotel.hotel_url"
                    class="btn_ w-100 book_no_margin hidden-sm hidden-md hidden-lg"
                    >VIEW DETAILS</a
                  >
                  <a
                    rel="nofollow"
                    :href="hotel.hotel_url"
                    class="btn_ w-100 book_no_margin hidden-xs"
                    >VIEW DETAILS</a
                  >
                </div>
                <div v-else>
                  <a
                    rel="nofollow"
                    :href="hotel.hotel_url"
                    class="btn_ w-100 book_no_margin hidden-sm hidden-md hidden-lg"
                    >Sign up for details</a
                  >
                  <a
                    rel="nofollow"
                    :href="hotel.hotel_url"
                    class="btn_ w-100 book_no_margin hidden-xs"
                    >Sign up for details</a
                  >
                </div>
              </div>
            </div>
            <div class="text-center mb-5" v-show="displaySpinner">
              <div>
                <div
                  class="ff-roboto text-black leading-6"
                  style="font-size: 1.2em"
                >
                  <SpinnerComponent class="w-12" />
                </div>
                <div>
                  <p
                    class="ff-roboto text-gray-dark leading-6"
                    style="font-size: 1.2em"
                  >
                    Searching hotels in progress ... {{ progress }} %
                  </p>

                </div>
              </div>
            </div>
            <div
              class="text-center mb-5"

            >
              <div v-show="hasChildren">
                <div>
                  <p
                    class="ff-roboto text-gray-dark leading-6"
                    style="font-size: 1.2em"
                  >
                    If you are looking for interconnecting rooms for your
                    family, contact
                    <a
                      class="orange h:black"
                      href="mailto:membersupport@privateupgrades.com"
                      >membersupport@privateupgrades.com</a>. We are happy to provide you with available options.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="map-div" v-if="hotels.length" v-show="mapView">
          <google-map-component
            :hotels="hotels"
            :key="hotelsLength"
            :requestInput="requestInput"
            :mapView="mapView"
            ref="GoogleMapRef"
          />
        </div>
      </div>
      <div id="suggested-hotels" class="col-md-12" v-if="hotels.length === 0">
        <div v-show="!hasChildren">
          <div
            v-show="!loading"
            class="col-md-12 col-xs-12 header-1 text-center ff-butler-regular"
            id="not-found"
            style="margin: 50px auto"
          >
            No hotels are available for the requested criteria. <br />Please
            adjust your timeframe or filter and click search again.
          </div>
        </div>

        <div v-show="hasChildren">
          <div
            v-show="!loading"
            class="col-md-12 col-xs-12 header-1 text-center ff-butler-regular"
            id="not-found"
            style="margin: 50px auto"
          >
          We couldn’t find room options for your search with children. Please adjust your search or contact us at  <a href="mailto:membersupport@privateupgrades.com">membersupport@privateupgrades.com</a> - our team is happy to assist.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "underscore";

import Lodash, { debounce } from "lodash";

import LoadingComponent from "./LoadingComponent";
import GoogleMapComponent from "./GoogleMapComponent";
import SpinnerComponent from "./SpinnerComponent.vue";

export default {
  name: "HotelComponent",
  props: [
    "requestInput",
    "pvariable",
    "title",
    "check_in_date",
    "check_out_date",
  ],
  components: {
    SpinnerComponent,
    LoadingComponent,
    GoogleMapComponent,
  },
  data() {
    return {
      loading: false,
      fetchingData: false,
      displaySpinner: false,
      localEnv: true,
      currentPage: 1,
      isLastPage: false,
      hasChildren: false,
      authCheck: false,
      selectedSortOption: "",
      selectedRangeFilter: [],
      initialSelectedRangeFilter: [],
      selectedRoomRangeFilter: [],
      initialSelectedRoomRangeFilter: [],
      selectedFilters: [],
      sliderFilters: [],
      hotelsClone: [],
      hotelsRange: [],
      hotels: [],
      progress: 0,
      progress_per_page: 0,
      paginateResults: true,
      slidersSet: false,
      rangeFiltersModified: false,
      roomsFiltersModified: false,
      totalHotels: 0,
      virtuosoAmenitiesList: [],
      virtuosoPromotionsList: [],
      privateHotelRecreationsList: [],
      privateHotelFeaturesList: [],
      privateHotelExperiencesList: [],
      privateHotelRoomsStylesList: [],
      privateHotelVibesList: [],
      sortOptions: [],
      mapView: false,
      hotelsLength: 0,
      _currency: null,
      oneNight: false,
      debouncedCheckScroll: null,
      tryingToFillRecords: false,
    };
  },
  created() {
    this.fetchData();
    this.debouncedCheckScroll = this.debounce(this.checkScroll, 200);
  },
  mounted() {
    this.startScrollCheck();
  },
  beforeDestroy() {
    this.stopScrollCheck();
  },
  watch: {
    selectedRangeFilter: function (a) {
      const initialRange = this.initializeRangeFilter();

      if (a[0] !== initialRange[0] || a[1] !== initialRange[1]) {
        this.rangeFiltersModified = true; // Assuming filtersModified is a property of this object
      }

      this.sliderFilters["range"] = a;

      this.applySliderFilters();
    },
    selectedRoomRangeFilter: function (a) {
      const initialRange = this.initializeRoomRangeFilter();

      if (a[0] !== initialRange[0] || a[1] !== initialRange[1]) {
        this.roomsFiltersModified = true; // Assuming filtersModified is a property of this object
      }

      this.sliderFilters["room"] = a;

      this.applySliderFilters();
    },
    selectedFilters: function (_selectedFilters) {
      this.filterByPerks(_selectedFilters);
    },
    selectedSortOption: function (a) {
      this.selectedFilters = [];

      this.sortResults(a);

      this.applySliderFilters();
    },
  },
  computed: {
    // currencySymbol: function () {
    //   return this._currency;
    // },

    orderedHotels: function () {
      return Lodash.orderBy(this.hotels, ["available"], ["desc"]);
    },

    virtuosoAmenities: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.virtuosoAmenitiesList;
      // }
      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.virtuosoAmenitiesList.filter((filter) => {
          return _.contains(hotel.filters, filter.code);
        });
        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "description");
    },
    virtuosoPromotions: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.virtuosoPromotionsList;
      // }

      let result = [];
      let items = [];

      this.hotels.forEach((hotel) => {
        items = this.virtuosoPromotionsList.filter((filter) => {
          return _.contains(hotel.filters, filter.code);
        });

        items.forEach((item) => {
          result.push(item);
        });
      });

      return _.sortBy(_.uniq(result), "description");
    },
    privateHotelRecreations: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.privateHotelRecreationsList;
      // }

      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.privateHotelRecreationsList.filter((filter) => {
          return _.contains(hotel.filters, filter.pu_title);
        });
        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "pi_title");
    },
    privateHotelFeatures: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.privateHotelFeaturesList;
      // }
      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.privateHotelFeaturesList.filter((filter) => {
          return _.contains(hotel.filters, filter.pu_title);
        });
        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "pu_title");
    },
    privateHotelExperiences: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.privateHotelExperiencesList;
      // }

      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.privateHotelExperiencesList.filter((filter) => {
          return _.contains(hotel.filters, filter.pu_title);
        });

        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "pu_title");
    },
    privateHotelRoomsStyles: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.privateHotelRoomsStylesList;
      // }

      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.privateHotelRoomsStylesList.filter((filter) => {
          return _.contains(hotel.filters, filter.pu_title);
        });

        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "pu_title");
    },
    privateHotelVibes: function () {
      // if (this.selectedFilters.length === 0) {
      //   return this.privateHotelVibesList;
      // }

      let result = [];
      let items = [];
      this.hotels.forEach((hotel) => {
        items = this.privateHotelVibesList.filter((filter) => {
          return _.contains(hotel.filters, filter.pu_title);
        });

        items.forEach((item) => {
          result.push(item);
        });
      });
      return _.sortBy(_.uniq(result), "pu_title");
    },
  },
  methods: {
    startScrollCheck() {
      this.checkScrollInterval = setInterval(this.checkScroll, 200); // Check every second
    },
    stopScrollCheck() {
      if (this.checkScrollInterval) {
        clearInterval(this.checkScrollInterval);
        this.checkScrollInterval = null;
      }
    },
    applySliderFilters: function () {
      const hotelsToFilter = this.hotelsClone;

      if (this.sliderFilters["range"] && this.rangeFiltersModified) {
        this.hotels = hotelsToFilter.filter((hotel) => {
          return (
            hotel.min_price >= this.sliderFilters["range"][0] &&
            hotel.min_price <= this.sliderFilters["range"][1]
          );
        });
      }

      if (this.sliderFilters["room"] && this.roomsFiltersModified) {
        this.hotels = this.hotels.filter((hotel) => {
          return (
            hotel.room_count >= this.sliderFilters["room"][0] &&
            hotel.room_count <= this.sliderFilters["room"][1]
          );
        });
      }

      if (this.selectedSortOption) {
        this.hotels = this.sortResults(this.selectedSortOption);
      }

      this.hotelsRange = this.hotels;

      this.updateAvailableHotelsCount();
    },
    setSliders() {
      return new Promise((resolve, reject) => {
        if (
          this.slidersSet &&
          $("#slider-range").hasClass("ui-slider") &&
          $("#slider-range-distance").hasClass("ui-slider")
        ) {
          resolve();
          return;
        }

        $("#slider-range").slider({
          range: true,
          min: 0,
          max: 0,
          values: [0, 0],
          slide: (event, ui) => {
            $("#amount").val(
              `${this.currencySymbol}${ui.values[0]} - ${this.currencySymbol}${ui.values[1]}`
            );
          },
          change: (event, ui) => {
            let min = ui.values[0];
            let max = ui.values[1];
            this.selectedRangeFilter = [min, max];
          },
        });

        $("#slider-range-distance").slider({
          range: true,
          min: 0,
          max: 0,
          values: [0, 0],
          slide: (event, ui) => {
            $("#miles").val(`${ui.values[0]} - ${ui.values[1]}`);
          },
          change: (event, ui) => {
            let min = ui.values[0];
            let max = ui.values[1];
            this.selectedRoomRangeFilter = [min, max];
          },
        });

        this.slidersSet = true;

        resolve();
      });
    },
    filterByRange(a) {
      this.selectedFilters = [];
      const [min, max] = a;
      //
      // if (!this.rangeFiltersModified) {
      //   return
      // }

      this.hotels = this.hotelsClone.filter((hotel) => {
        return hotel.min_price >= min && hotel.min_price <= max;
      });

      this.hotelsRange = this.hotels;

      this.updateAvailableHotelsCount();
    },
    filterByRoom(a) {
      this.selectedFilters = [];
      let [min, max] = a;

      // if (!this.roomsFiltersModified) {
      //   return
      // }

      this.hotels = this.hotelsClone.filter((hotel) => {
        return hotel.room_count >= min && hotel.room_count <= max;
      });

      this.hotelsRange = this.hotels;
      this.updateAvailableHotelsCount();
    },
    sortResults(a) {
      if (a === "price-asc") {
        this.hotels = this.hotels.sort((a, b) => {
          if (a.min_price < b.min_price) {
            return -1;
          }
          if (a.min_price > b.min_price) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });
      } else if (a === "price-desc") {
        this.hotels = this.hotels.sort((a, b) => {
          if (a.min_price > b.min_price) {
            return -1;
          }
          if (a.min_price < b.min_price) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });
      } else if (a === "new") {
        this.hotels = this.hotels.filter((hotel) => hotel.is_new);
      } else if (a === "featured") {
        this.hotels = this.hotels.filter((hotel) => hotel.is_featured);
      }

      return this.hotels;
    },
    filterByPerks(_selectedFilters) {
      // if (_selectedFilters.length > 0)
      // {
      this.hotels = this.hotelsRange.filter((hotel) => {
        // if (hotel.filters.length)
        {
          let allMatched = true;
          _selectedFilters.forEach((filterCode) => {
            if (_.contains(hotel.filters, filterCode) === false) {
              allMatched = false;
            }
          });
          return allMatched;
        }
      });
      // }

      this.updateAvailableHotelsCount();
    },
    initializeRangeFilter() {
      let min = 0;
      let max = 0;

      if (this.hotels.length > 0) {
        let minPrices = this.hotels
          .map((hotel) => Math.round(hotel.min_price))
          .filter((a) => Number(a));
        if (minPrices.length) {
          max = Math.max(...minPrices);
          min = Math.min(...minPrices);
        }
      }

      return [min, max];
    },
    initializeRoomRangeFilter() {
      let roomMax = 0;
      let roomMin = 0;

      if (this.hotels.length > 0) {
        let roomsCount = this.hotels
          .map((hotel) => hotel.room_count)
          .filter((a) => Number(a));
        roomMax = Math.max(...roomsCount);
        roomMin = Math.min(...roomsCount);
      }

      return [roomMin, roomMax];
    },
    updateMap() {
      if (this.mapView) this.mapView = false;
      else this.mapView = true;

      this.$refs.GoogleMapRef.initMap();
    },
    sortByPriceDesc() {
      this.hotels = this.hotels.sort((a, b) => {
        if (a.min_price > b.min_price) {
          return -1;
        }
        if (a.min_price < b.min_price) {
          return 1;
        }
        // a must be equal to b
        return 0;
      });
    },
    resetSliders() {
      let min = this.initialSelectedRangeFilter[0];
      let max = this.initialSelectedRangeFilter[1];

      $("#slider-range").slider("option", "min", min);
      $("#slider-range").slider("option", "max", max);

      if (!this.rangeFiltersModified) {
        $("#slider-range").slider("option", "values", [min, max]);

        $("#amount").val(
          `${this.currencySymbol}` +
            $("#slider-range").slider("values", 0) +
            ` - ${this.currencySymbol}` +
            $("#slider-range").slider("values", 1)
        );
      }

      let roomMin = this.initialSelectedRoomRangeFilter[0];
      let roomMax = this.initialSelectedRoomRangeFilter[1];

      $("#slider-range-distance").slider("option", "min", roomMin);
      $("#slider-range-distance").slider("option", "max", roomMax);

      if (!this.roomsFiltersModified) {
        $("#slider-range-distance").slider("option", "values", [
          roomMin,
          roomMax,
        ]);

        $("#miles").val(
          "" +
            $("#slider-range-distance").slider("values", 0) +
            " - " +
            $("#slider-range-distance").slider("values", 1)
        );
      }
    },
    resetFilter() {
      this.selectedFilters = [];
      this.hotels = this.hotelsClone;
      this.hotelsRange = this.hotels;
      this.selectedSortOption = "";
      // this.slidersSet = false;
      this.roomsFiltersModified = false;
      this.rangeFiltersModified = false;

      this.setSliders().then(() => {
        this.resetSliders();
      });
    },
    uniqueMergeBy(a, b, field) {
      return _.uniq(a.concat(b), field);
    },
    fetchData(page = 1, retry = false, performedAttempts = 0) {
      let attempts = performedAttempts;
      this.fetchingData = true;
      this.displaySpinner = true;

      if (!retry && page === 1) {
        this.loading = true;
      } else {
        attempts++;
        this.tryingToFillRecords = true;
        this.requestInput["skip_waiting"] = true;
      }

      this.requestInput["page"] = page;

      if (this.requestInput["children_ages"]) {
        if (this.requestInput["children"] > 0) {
          this.hasChildren = true;
        }
        this.requestInput["children_ages"] = Object.values(
          this.requestInput["children_ages"]
        ).filter((age) => age !== null && age !== undefined && age !== "");
      }

      fetch(
        this.$baseUrl +
          "/api/search/fetchData?" +
          new URLSearchParams(this.requestInput)
      )
        .then((response) => response.json())
        .then((data) => {
          // Set state only on the initial load or if the number of hotels from the previous load is less than 10
          this.authCheck = data.authCheck;
          this.localEnv = data.localEnv;
          this.totalHotels = data.totalHotels;
          this.paginateResults = data.paginateResults;
          //
          // if (retry) {
          //   const startIndex = (page - 1) * 10;
          //   this.hotels.splice(startIndex, data.hotels.length, ...data.hotels);
          // } else {
          this.hotels = data.hotels;
          // }

          this.virtuosoAmenitiesList = this.uniqueMergeBy(
            this.virtuosoAmenitiesList,
            data.filters.virtuosoAmenities,
            "code"
          );
          this.virtuosoPromotionsList = this.uniqueMergeBy(
            this.virtuosoPromotionsList,
            data.filters.virtuosoPromotions,
            "code"
          );
          this.privateHotelRecreationsList = this.uniqueMergeBy(
            this.privateHotelRecreationsList,
            data.filters.privateHotelRecreations,
            "title"
          );
          this.privateHotelFeaturesList = this.uniqueMergeBy(
            this.privateHotelFeaturesList,
            data.filters.privateHotelFeatures,
            "title"
          );
          this.privateHotelExperiencesList = this.uniqueMergeBy(
            this.privateHotelExperiencesList,
            data.filters.privateHotelExperiences,
            "title"
          );
          this.privateHotelRoomsStylesList = this.uniqueMergeBy(
            this.privateHotelRoomsStylesList,
            data.filters.privateHotelRoomsStyles,
            "title"
          );
          this.privateHotelVibesList = this.uniqueMergeBy(
            this.privateHotelVibesList,
            data.filters.privateHotelVibes,
            "title"
          );

          this.isLastPage = data.isLastPage;
          this.currentPage = data.currentPage;
          this.sortOptions = data.sort_options;
          this.hotelsClone = this.hotels;
          this.hotelsLength = this.hotels.length;
          this.currencySymbol = data.currency;
          this._currency = data.currency;
          this.oneNight = data.oneNight;
          this.gtmDataLayer = data.gtmDataLayer;
          this.hotelsRange = this.hotels;
          this.progress = data.progress;
          this.progress_per_page = data.progress_per_page;

          this.initialSelectedRangeFilter = this.initializeRangeFilter();
          this.initialSelectedRoomRangeFilter =
            this.initializeRoomRangeFilter();

          $(() => {
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push(this.gtmDataLayer);

            this.setSliders().then(() => {
              this.resetSliders();
            });
          });

          if (this.selectedRangeFilter.length > 0) {
            this.applySliderFilters();
          }

          this.filterByPerks(this.selectedFilters);
          this.updateAvailableHotelsCount();

          this.loading = false;

          if (
            (!data.paginateResults && data.progress < 100) ||
            (data.paginateResults && data.progress_per_page < 100)
          ) {
            setTimeout(() => {
              this.fetchData(page, true, attempts);
            }, 1000);
          }

          if (this.isLastPage) {
            this.displaySpinner = false;
          }

          this.fetchingData = false;
        });
    },
    fetchMoreResult() {
      let page = parseInt(this.currentPage) + 1;

      if (this.fetchingData) {
        return;
      }

      if (this.loading) {
        return;
      }

      if (!this.isLastPage) {
        this.fetchData(page);
      }
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },
    checkScroll(event) {
      if (this.paginateResults && this.progress_per_page < 100) {
        return;
      }

      const container = this.$refs.scrollContainer;

      const scrollTop = window.scrollY;
      const containerHeight = window.innerHeight;
      const fullHeight = container ? container.scrollHeight : 0;

      //   console.log(scrollTop + containerHeight - 200);
      //   console.log(fullHeight);
      //   console.log(scrollTop + containerHeight - 200 >= fullHeight);

      if (scrollTop + containerHeight - 200 >= fullHeight) {
        this.fetchMoreResult();
      }
    },
    updateAvailableHotelsCount() {
      this.hotelsLength = this.hotels.length;
      this.$emit("update-hotel-count", {
        hotels: this.hotels.length,
        totalHotels: this.totalHotels,
        progress: this.progress,
        paginateResults: this.paginateResults,
      });
    },
  },
};
</script>

<style scoped>
.btn-load-more {
  padding: 15px;
  font-size: 18px;
  cursor: pointer;
  font-family: "Lato" !important;
  text-transform: uppercase;
}

.btn-load-more:hover {
  text-decoration: underline;
}

.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  /* font-size: 32px; */
  background: #222121c2;
  z-index: 9999;
  padding-top: 16rem;
}

.reset-filter {
  width: 80%;
  border: solid 1px;
}

.hotel-icons li {
  height: 32px;
  margin-bottom: 7px;
}

.filters .filter-options {
  display: grid !important;
  align-content: normal;
}

#content.search #columnsearch .hotellist .image-wrap {
  height: 260px;
}

.hotel-icons .hotel-bed {
  font-size: 2em;
}

.w-12 {
  width: 65px;
}
</style>
